import { Col, Row } from 'antd';
import React from 'react';

const AuthLayout = WraperContent => {
  return () => {
    return (
      <Row>
        <Col span={8}>
        </Col>
        <Col xxl={24} xl={24} md={8} xs={24}>
          <WraperContent />
        </Col>
        <Col span={8}>
        </Col>
      </Row>
    );
  };
};

export default AuthLayout;
